// extracted by mini-css-extract-plugin
module.exports = {"bio":"bio-module--bio--1wXtm"};